/// <reference path="../../lib/jquery.d.ts" />

/**
 * Generic controller class to entcapsulate the parsing
 * and other generic stuff
 *
 * @export
 * @class Controller
 */
export class Controller {

    /**
     * Selector which will be overwritten from the
     * other Controllers so the parse function
     * can directly query according to that selector.
     *
     * @static
     * @type {string}
     */
    static selector: string;

    

    /**
     * HTML attribute to mark elements which are already parsed
     *
     * @static
     */
    static PARSE_ID_ATTRIBUTE = 'data-parse-id';

    /**
     * Element where the instance is applied
     *
     * @private
     * @type {Element}
     */
    protected _element: HTMLElement;

    /**
     * Access element or query by selector
     */
    get $() {
        return (selector?: string): any => {
            if (!(this._element instanceof Element)) {
                throw new Error('This controller has no element!');
            }
            return selector ? this._element.querySelectorAll(selector) : $(this._element);
        }
    }
    set $(value) {
        throw new Error('Setting $ is not allowed');
    }


    /**
     * Creates an instance of a Controller.
     *
     * @param element root The element where the controller has been applied
     */
    constructor(element: HTMLElement) {
        this._element = element;

        let className: string;
        // @ts-ignore
        className = this.constructor.name;
        className = className.toLocaleLowerCase();
        if (element.getAttribute(Controller.PARSE_ID_ATTRIBUTE + '-' + className)) {
            return;
        }
        element.setAttribute(Controller.PARSE_ID_ATTRIBUTE + '-' + className, Math.floor(Math.random() * 10 + 1) * Date.now() + '');
    }
}